"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = pwa;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _notify = _interopRequireDefault(require("./notify"));
var _networkChange = _interopRequireDefault(require("./networkChange"));
var _sync = _interopRequireDefault(require("./sync"));
var _register = _interopRequireDefault(require("./register"));
var _clearCache = _interopRequireDefault(require("./clearCache"));
function pwa() {
  return _pwa.apply(this, arguments);
}
function _pwa() {
  _pwa = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
    var p,
      wapp,
      _wapp$globals,
      globals,
      DEV,
      _p$clearCachesEnabled,
      clearCachesEnabled,
      _p$clearCachesResolve,
      clearCachesResolve,
      _p$clearCachesReject,
      clearCachesReject,
      _p$enableNotification,
      enableNotifications,
      _p$notifyResolve,
      notifyResolve,
      _p$notifyReject,
      notifyReject,
      _p$onlineHandler,
      onlineHandler,
      _p$offlineHandler,
      offlineHandler,
      _p$syncReject,
      syncReject,
      _p$syncReadyHandler,
      syncReadyHandler,
      _p$enableServiceWorke,
      enableServiceWorker,
      _p$serviceWorkerResol,
      _serviceWorkerResolve,
      _p$serviceWorkerRejec,
      serviceWorkerReject,
      _args2 = arguments;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          p = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          wapp = p.wapp;
          _wapp$globals = wapp.globals, globals = _wapp$globals === void 0 ? {} : _wapp$globals;
          DEV = globals.DEV;
          _p$clearCachesEnabled = p.clearCachesEnabled, clearCachesEnabled = _p$clearCachesEnabled === void 0 ? DEV : _p$clearCachesEnabled, _p$clearCachesResolve = p.clearCachesResolve, clearCachesResolve = _p$clearCachesResolve === void 0 ? function (_ref) {
            var cleared = _ref.cleared;
            if (cleared.length) {
              console.log("[PWA] Caches cleared: " + cleared.join(", "));
            } else {
              console.log("[PWA] There are not caches");
            }
          } : _p$clearCachesResolve, _p$clearCachesReject = p.clearCachesReject, clearCachesReject = _p$clearCachesReject === void 0 ? function (_ref2) {
            var err = _ref2.err;
            if (err) {
              console.log("[PWA] Clear cache error: " + err.message);
            }
          } : _p$clearCachesReject, _p$enableNotification = p.enableNotifications, enableNotifications = _p$enableNotification === void 0 ? false : _p$enableNotification, _p$notifyResolve = p.notifyResolve, notifyResolve = _p$notifyResolve === void 0 ? function (_ref3) {
            var reg = _ref3.reg;
            console.log("[PWA] Permitted notifications");
          } : _p$notifyResolve, _p$notifyReject = p.notifyReject, notifyReject = _p$notifyReject === void 0 ? function (_ref4) {
            var err = _ref4.err,
              info = _ref4.info;
            if (err) {
              console.log("[PWA] Notify error: " + err.message);
            } else if (info) {
              console.info("[PWA] Notify info: " + info.message);
            }
          } : _p$notifyReject, _p$onlineHandler = p.onlineHandler, onlineHandler = _p$onlineHandler === void 0 ? function (_ref5) {
            var reg = _ref5.reg;
            console.log("[PWA] Online again");
          } : _p$onlineHandler, _p$offlineHandler = p.offlineHandler, offlineHandler = _p$offlineHandler === void 0 ? function (_ref6) {
            var reg = _ref6.reg;
            console.log("[PWA] Lost connection");
          } : _p$offlineHandler, _p$syncReject = p.syncReject, syncReject = _p$syncReject === void 0 ? function () {
            var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var err = p.err;
            if (err) {
              console.log("[PWA] Failed to register sync: " + err.message);
            } else {
              console.log("[PWA] Serviceworker/sync not supported");
            }
          } : _p$syncReject, _p$syncReadyHandler = p.syncReadyHandler, syncReadyHandler = _p$syncReadyHandler === void 0 ? ( /*#__PURE__*/function () {
            var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(_ref7) {
              var reg;
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    reg = _ref7.reg;
                    console.log("[PWA] Sync service is ready");
                    return _context.abrupt("return", reg.sync.register("syncTag").then(function () {
                      console.log("[PWA] Sync registered");
                    })["catch"](function (err) {
                      syncReject({
                        err: err
                      });
                    }));
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref8.apply(this, arguments);
            };
          }()) : _p$syncReadyHandler, _p$enableServiceWorke = p.enableServiceWorker, enableServiceWorker = _p$enableServiceWorke === void 0 ? true : _p$enableServiceWorke, _p$serviceWorkerResol = p.serviceWorkerResolve, _serviceWorkerResolve = _p$serviceWorkerResol === void 0 ? function (_ref9) {
            var reg = _ref9.reg;
            console.log("[PWA] Service Worker registered");
          } : _p$serviceWorkerResol, _p$serviceWorkerRejec = p.serviceWorkerReject, serviceWorkerReject = _p$serviceWorkerRejec === void 0 ? function () {
            var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var err = p.err,
              info = p.info;
            if (err) {
              console.log("[PWA] ServiceWorker error: " + err.message);
            } else if (info) {
              console.info("[PWA] ServiceWorker info: " + info.message);
            }
          } : _p$serviceWorkerRejec;
          if (!(typeof wapp.pwa == "undefined")) {
            _context2.next = 12;
            break;
          }
          Object.defineProperty(wapp, "pwa", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
          });
          _context2.next = 9;
          return (0, _clearCache["default"])((0, _objectSpread2["default"])({
            clearCachesEnabled: clearCachesEnabled,
            clearCachesResolve: clearCachesResolve,
            clearCachesReject: clearCachesReject
          }, p));
        case 9:
          _context2.next = 11;
          return (0, _register["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
            enableServiceWorker: enableServiceWorker,
            serviceWorkerReject: serviceWorkerReject
          }, p), {}, {
            serviceWorkerResolve: function serviceWorkerResolve(_ref10) {
              var reg = _ref10.reg;
              wapp.pwa = reg;
              if (_serviceWorkerResolve) {
                _serviceWorkerResolve({
                  reg: reg
                });
              }
              (0, _notify["default"])((0, _objectSpread2["default"])({
                enableNotifications: enableNotifications,
                notifyResolve: notifyResolve,
                notifyReject: notifyReject
              }, p));
              (0, _networkChange["default"])((0, _objectSpread2["default"])({
                onlineHandler: onlineHandler,
                offlineHandler: offlineHandler
              }, p));
              (0, _sync["default"])((0, _objectSpread2["default"])({
                syncReadyHandler: syncReadyHandler,
                syncReject: syncReject
              }, p));
            }
          }));
        case 11:
          Object.defineProperty(wapp.pwa, "wapp", {
            configurable: false,
            writable: false,
            enumerable: false,
            value: wapp
          });
        case 12:
          return _context2.abrupt("return", wapp.pwa);
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _pwa.apply(this, arguments);
}